const ProfileIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon" clipPath="url(#clip0_33_267)">
        <path
          id="circle-user"
          d="M10 0C4.47656 0 0 4.47656 0 10C0 15.5234 4.47656 20 10 20C15.5234 20 20 15.5234 20 10C20 4.47656 15.5234 0 10 0ZM10 18.75C8.15469 18.75 6.44375 18.1727 5.03125 17.1938C5.19141 15.2695 6.78906 13.75 8.75 13.75H11.25C13.2129 13.75 14.8102 15.2711 14.9691 17.1938C13.5547 18.1719 11.8438 18.75 10 18.75ZM16.082 16.2773C15.5312 14.1133 13.582 12.5 11.25 12.5H8.75C6.4168 12.5 4.46875 14.1133 3.91797 16.2781C2.27617 14.6523 1.25 12.4609 1.25 10C1.25 5.17578 5.17578 1.25 10 1.25C14.8242 1.25 18.75 5.17578 18.75 10C18.75 12.4609 17.7227 14.6523 16.082 16.2773ZM10 5C8.27344 5 6.875 6.39844 6.875 8.125C6.875 9.85156 8.27344 11.25 10 11.25C11.7266 11.25 13.125 9.85078 13.125 8.125C13.125 6.39844 11.7266 5 10 5ZM10 10C8.96484 10 8.125 9.16016 8.125 8.125C8.125 7.08984 8.96484 6.25 10 6.25C11.0352 6.25 11.875 7.09102 11.875 8.125C11.875 9.15898 11.0352 10 10 10Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_33_267">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ProfileIcon;
